const productObject = {
  "oldReference": "",
  "name": "",
  "description": "",
  "cost": 0,
  "supplier": "",
  "manufacturer": "",
  "cashPrice": 0,
  "buyDate": "",
  "size": {
    "nb": 0,
    "s": 0,
    "m": 0,
    "b": 0,
    "oneYear": 0,
    "twoYear": 0,
    "un": 0
  },
  "material": "",
  "colors": [],
  "gender": [],
  "status": false,
  "tags": [],
  "thumbs": [],
  "promptDelivery": false,
};

export default productObject;
